module.exports = __webpack_public_path__ + "img/1707036384868-a-rain.txt.b409bc50.webp";